export default "__VITE_ASSET__PIQiSnLd__"